import React from 'react'
import moment from 'moment'
import firebase from './firebase'

export const Context = React.createContext()

export default class ContextProvider extends React.Component {

  constructor(props) {
    super(props)

    this.authUser = this.authUser.bind(this)

    this.state = {
      todos: [],
      textFilter: '',
      undo: [],
      isAuthenticating: true,
      user: null,
      theme: {
        backgroundImage: '/images/bricks.jpg',
        backgroundColor: 'rgb(240,192,136)',
        logo: '/images/wendoe_logo.png'
      }
    }

    /*const themeRef = firebase.database().ref('theme');
    themeRef.on('value', (snapshot) => {
      let theme = snapshot.val();
      this.setState({
        theme: theme
      });
    });*/


  }

  authUser() {
   return new Promise( (resolve, reject) => {
      firebase.auth().onAuthStateChanged( (user) => {
         if (user) {
            this.setState({ user })
             const userRef = firebase.database().ref(`users/${user.uid}`)
             userRef.once('value').then(snapshot => {
               let firebaseStoredUser = snapshot.val()
               if (!firebaseStoredUser) {
                 firebase.database().ref(`users/${user.uid}`).set({
                   displayName: user.displayName,
                   email: user.email,
                   photoURL: user.photoURL
                 })
               }
             })

             const itemsRef = firebase.database().ref(`todos/${user.uid}`);
             itemsRef.on('value', (snapshot) => {
               let items = snapshot.val();
               let newState = [];
               for (let item in items) {
                 newState.push({
                   id: item,
                   ...items[item]
                 });
               }
               this.setState({
                 todos: newState
               });
             });

             resolve(user);
         } else {
            this.setState({user: null, todos: [], textFilter: '', undo: []});
            reject('User not logged in');
         }
      });
   });
  }

  componentDidMount() {
    this.authUser().then((user) => {
       this.setState({ isAuthenticating: false });
    }, (error) => {
       this.setState({ isAuthenticating: false });
       console.log(error)
    });
  }

  render() {
    return(
      <Context.Provider value={{
          globalState: this.state,
          actions: {

            signOut: () => {
              firebase.auth().signOut().then(() => {
                this.setState({user: null, todos: [], textFilter: '', undo: []});
              }).catch(function(error) {
                console.error(error)
              });

            },

            textSearch: (textFilter) => {

              this.setState({textFilter})

            },

            toggleDone: (itemId) => {

              const itemRef = firebase.database().ref(`todos/${this.state.user.uid}/${itemId}`)

              itemRef.once('value').then(snapshot => {
                let item = snapshot.val()
                itemRef.update({
                  isDone: item.isDone ? false : true,
                  doneDate: item.isDone ? null : moment().format()
                })
              })

            },

            addItem: (content, duedate, list) => {

              const itemsRef = firebase.database().ref(`todos/${this.state.user.uid}`)

              const newItem = {
                content: content,
                order: -1,
                duedate: duedate,
                originalDueDate: duedate,
                isDone: false,
                created: moment().format(),
                doneDate: null
              }
              itemsRef.push(newItem)

              list.shift(newItem)

              list.forEach( (item, index) => {
                firebase.database().ref(`todos/${this.state.user.uid}/${item.id}`).update({
                  order: index
                })
              })
            },

            updateItem: (itemId, content, duedate) =>

              firebase.database().ref(`todos/${this.state.user.uid}/${itemId}`).update({
                content: content,
                duedate: duedate
              }),

            updateOrder: (list) =>

              list.forEach( (item, index) => {
                firebase.database().ref(`todos/${this.state.user.uid}/${item.id}`).update({
                  order: index
                })
              }),
          }
        }}>
        {this.props.children}
      </Context.Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Context.js